import React, { useEffect, useMemo, useState } from 'react'
import {
    Form,
    Input,
    Button,
    Switch,
    Row,
    Col,
    Space,
    DatePicker,
    Select,
    type DatePickerProps,
    Tooltip,
} from 'antd'
import { SaveOutlined } from '@ant-design/icons'
import commonStyles from '../../../../../../Utils/Common.less'
import {
    type TogilleAddress,
    type ServiceCorporatepaye,
    type PayeStateInterface,
} from '../../../../../../Types/Client/RegisteredClients/Corporate'

import { connect, useDispatch } from 'react-redux'
import {
    GetAddress,
    SavepayeServices,
} from '../../../../../../Services/Corporate'
import { type ListFrontEndInterface } from '../../../../../../Types/CommonType'
import {
    GetCountryList,
    GetPayeProcessData,
} from '../../../../../../Services/Common'
import Servicesless from '../../../../../../Layouts/Less/style.less'
import moment from 'moment'
import dayjs from 'dayjs'
import ActivePremission from '../../../../../../Utils/premissins'
import { PermissionType } from '../../../../../../Types/Enum/PermissionType'
import PostCodeInput from '../../../../../../Components/PostCodeInput'
import { getValidationRules } from '../../../../../../Utils/validatefiled'
const { Option } = Select
const PayeForm = ({
    PAYEServiceData,
    isEditMode,
    countryList,
    corporateId,
    onSave,
    payeProcessList,
}: {
    PAYEServiceData: ServiceCorporatepaye | null
    isEditMode: boolean
    countryList: ListFrontEndInterface[]
    corporateId: number
    payeProcessList: ListFrontEndInterface[]
    onSave: () => void
}): React.ReactElement => {
    const dispatch = useDispatch()
    const [form] = Form.useForm()
    const [SchemeStartDate, setSelectedDate] = useState<string>('')
    const [buttonloading, setButtonLoading] = useState(false)
    const [servicesEnabled, setServicesEnabled] = useState(
        PAYEServiceData?.status === 'Active'
    )
    const [CSIEnabled, setServicescs1Enabled] = useState(false)
    const [payrollFrequencyid, setPayRolleFeqency] = useState('')
    const [switchStates, setSwitchStates] = useState<{
        1: boolean
        2: boolean
        3: boolean
    }>({
        1: false,
        2: false,
        3: false,
    })
    const [payeProcessId, setPayeProcessId] = useState(0)

    const [address, setAddress] = useState({
        line_1: '',
        line_2: '',
        line_3: '',
        post_town: '',
        postcode: '',
        country: '',
    })
    useEffect(() => {
        const countryData = countryList?.find(
            (data: ListFrontEndInterface) =>
                data.label === address?.country?.toUpperCase()
        )
        if (address.line_1 !== '') {
            const AddressData = {
                town: address.post_town,
                country: countryData?.label ?? '',
                postCode: address.postcode,
                addressLineOne: address?.line_1,
                addressLineTwo: address?.line_2,
            }
            form.setFieldsValue(AddressData)
        }
    }, [address])

    const handleSwitchChange = (switchId: 1 | 2 | 3): void => {
        const newSwitchStates = {
            1: false,
            2: false,
            3: false,
        }
        if (!switchStates[switchId]) {
            newSwitchStates[switchId] = true
            void GetAddress(
                dispatch,
                corporateId,
                switchId,
                (addressData: TogilleAddress) => {
                    form.setFieldsValue({
                        addressLineOne: addressData.addressLineOne ?? '',
                        addressLineTwo: addressData.addressLineTwo ?? '',
                        town: addressData.town ?? '',
                        country: addressData.country ?? '',
                        postCode: addressData.postCode ?? '',
                    })
                }
            )
        } else {
            form.setFieldsValue({
                addressLineOne: '',
                addressLineTwo: '',
                town: '',
                country: '',
                postCode: '',
            })
        }
        setSwitchStates(newSwitchStates)
    }

    useEffect(() => {
        GetCountryList(dispatch)
        GetPayeProcessData(dispatch)
    }, [dispatch])

    useEffect(() => {
        if ((PAYEServiceData ?? null) !== null && isEditMode) {
            const countryData = countryList?.find(
                (data: ListFrontEndInterface) =>
                    data.label === PAYEServiceData?.country
            )
            const newData = {
                ...PAYEServiceData,
                country: countryData != null ? countryData.value : '',
            }
            form.setFieldsValue(newData)
        }
    }, [PAYEServiceData, isEditMode])

    useEffect(() => {
        if (PAYEServiceData != null && isEditMode) {
            form.setFieldsValue({
                accountOfficeReference: PAYEServiceData?.accountOfficeReference,
                csiFiling: PAYEServiceData?.csiFiling,
                filingMethodName: PAYEServiceData?.filingMethodName,
                gateWayId: PAYEServiceData?.gateWayId,
                hmrcPaymentFrequency: PAYEServiceData?.hmrcPaymentFrequency,
                hmrcPaymentFrequencyName:
                    PAYEServiceData?.hmrcPaymentFrequencyName,
                password: PAYEServiceData?.password,
                payeId: PAYEServiceData?.payeId,
                payeProcess: PAYEServiceData?.payeProcess,
                payeProcessName: PAYEServiceData?.payeProcessName,
                payrollFrequency: PAYEServiceData?.payrollFrequency,
                postCode: PAYEServiceData?.postCode,
                schemeStartDate: PAYEServiceData?.schemeStartDate,

                town: PAYEServiceData?.town,
                filingMethod: PAYEServiceData?.filingMethod,
                addressLineTwo: PAYEServiceData?.addressLineTwo,
                addressLineOne: PAYEServiceData?.addressLineOne,
                country: PAYEServiceData?.country,
                status: PAYEServiceData?.status,
                payeReference: PAYEServiceData?.payeReference,
                companyType: PAYEServiceData?.companyType,
            })
            setPayRolleFeqency(PAYEServiceData?.payrollFrequency)
        }
    }, [PAYEServiceData, isEditMode, form])

    useEffect(() => {
        if (PAYEServiceData !== null) {
            setSelectedDate(PAYEServiceData.schemeStartDate)
        }
    }, [PAYEServiceData])
    useEffect(() => {
        form.setFieldValue('schemeStartDate', SchemeStartDate)
    }, [SchemeStartDate])

    const onChangeStartDate = (
        schemeStartDate: DatePickerProps['value'],
        dateString: string | string[]
    ): void => {
        if (schemeStartDate != null) {
            const isoDate = schemeStartDate.toISOString()
            setSelectedDate(isoDate)
            form.setFieldValue('schemeStartDate', isoDate)
            void form.validateFields(['schemeStartDate'])
        }
    }
    const handleClick = async (): Promise<void> => {
        try {
            await form.validateFields()
            setButtonLoading(true)
            const formData = form.getFieldsValue()
            const hmrcPaymentFrequencyName = formData.hmrcPaymentFrequencyName
            let hmrcPaymentFrequency: number
            if (hmrcPaymentFrequencyName === 'MONTHLY') {
                hmrcPaymentFrequency = 1
            } else {
                hmrcPaymentFrequency = 2
            }

            const filingMethodName = formData.filingMethodName
            let filingMethod: number
            if (filingMethodName === 'Nil Return') {
                filingMethod = 1
            } else if (filingMethodName === 'Standard Filing') {
                filingMethod = 2
            } else if (
                filingMethodName === 'Hours to be obtained WEEKLY Filing'
            ) {
                filingMethod = 3
            } else {
                filingMethod = 0
            }

            const dataToSave = {
                payeId: PAYEServiceData?.payeId ?? 0,
                companyType: PAYEServiceData?.companyType ?? 1,
                referenceId: corporateId,
                payeReference: formData?.payeReference ?? '',
                accountOfficeReference: formData?.accountOfficeReference ?? '',
                payrollFrequency: payrollFrequencyid ?? '',
                schemeStartDate: moment(formData.schemeStartDate).format(
                    'DD/MM/YYYY'
                ),
                addressLineTwo: formData?.addressLineTwo ?? '',
                addressLineOne: formData?.addressLineOne ?? '',
                town: formData?.town ?? '',
                country: formData?.country ?? '',
                postCode: formData?.postCode ?? '',
                gateWayId: formData?.gateWayId ?? '',
                password: formData?.password ?? '',
                status: servicesEnabled ? 'Active' : 'Inactive',
                csiFiling: CSIEnabled ? 1 : 0,
                payeProcess: payeProcessId ?? 0,
                filingMethod: filingMethod ?? 0,
                payeProcessName: PAYEServiceData?.payeProcessName ?? '',
                filingMethodName: formData?.filingMethodName ?? '',
                hmrcPaymentFrequency: hmrcPaymentFrequency ?? 0,
                hmrcPaymentFrequencyName:
                    formData?.hmrcPaymentFrequencyName ?? '',
                payeProcessDate: formData?.payeProcessDate ?? '01/01/1900',
            }
            await SavepayeServices(dispatch, dataToSave).then((result) => {
                if (result !== null && result !== undefined) {
                    onSave()
                    setButtonLoading(false)
                }
            })
        } catch (error) {}
    }

    const handleServiceSwitchChange1 = (checked: boolean): void => {
        setServicesEnabled(checked)
    }
    const handleServiceSwitchChange2 = (checked: boolean): void => {
        setServicescs1Enabled(checked)
    }
    const handelpayrollFrequencyChange = (value: string): void => {
        setPayRolleFeqency(value)
    }

    const hanldePayeProcessIdchange = (value: number): void => {
        setPayeProcessId(value)
    }

    const customizeRequiredMark = (
        label: React.ReactNode,
        { required }: { required: boolean }
    ): React.ReactElement => (
        <>
            {label}
            &nbsp;
            {required && <span className={commonStyles.requireIcon}>*</span>}
        </>
    )
    const rules = useMemo(
        () => getValidationRules(servicesEnabled),
        [servicesEnabled]
    )
    return (
        <div className={commonStyles.formWrapper}>
            <Form
                form={form}
                name="ct-form"
                layout={'vertical'}
                autoComplete="off"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                requiredMark={customizeRequiredMark}
            >
                <Row gutter={24} className={Servicesless.services}>
                    <Col span={8}>
                        <Form.Item
                            label="Same as Office"
                            name="officeSwitch"
                            labelCol={{ span: 16 }}
                            wrapperCol={{ span: 8 }}
                        >
                            <Switch
                                id="1"
                                checked={switchStates[1]}
                                onChange={() => {
                                    handleSwitchChange(1)
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            label="Same as Business"
                            name="businessSwitch"
                            labelCol={{ span: 16 }}
                            wrapperCol={{ span: 8 }}
                        >
                            <Switch
                                id="2"
                                checked={switchStates[2]}
                                onChange={() => {
                                    handleSwitchChange(2)
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            label="Same as Correspondence"
                            name="correspondenceSwitch"
                            labelCol={{ span: 16 }}
                            wrapperCol={{ span: 8 }}
                        >
                            <Switch
                                id="3"
                                checked={switchStates[3]}
                                onChange={() => {
                                    handleSwitchChange(3)
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16} className={Servicesless.services}>
                    <Col span={12}>
                        <Form.Item
                            label="PAYE Reference"
                            rules={rules.payeReference}
                            name="payeReference"
                        >
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="addressLineTwo" label="Address 2">
                            <Input allowClear maxLength={100} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16} className={Servicesless.services}>
                    <Col span={12}>
                        <Form.Item
                            label="Account Office Reference"
                            name="accountOfficeReference"
                            rules={rules.accountOfficeReference}
                        >
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Town " name="town" rules={rules.town}>
                            <Input allowClear maxLength={50} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16} className={Servicesless.services}>
                    <Col span={12}>
                        <Form.Item
                            label="Payroll Frequency"
                            name="payrollFrequency"
                            rules={rules.payrollFrequency}
                        >
                            <Select
                                allowClear
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    typeof option?.children === 'string' && // Ensure option.children is a string
                                    (option.children as string)
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                onChange={(value) => {
                                    handelpayrollFrequencyChange(value)
                                }}
                            >
                                <Option value="WEEKLY">WEEKLY</Option>
                                <Option value="BI WEEKLY">BI WEEKLY</Option>
                                <Option value="FOUR WEEKLY">FOUR WEEKLY</Option>
                                <Option value="MONTHLY">MONTHLY</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Country " name="country">
                            <Select
                                allowClear
                                placeholder="Please select"
                                showSearch
                                onChange={() => {}}
                                options={countryList?.map((country) => ({
                                    value: country.label,
                                    label: country.label,
                                }))}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16} className={Servicesless.services}>
                    <Col span={12}>
                        <Form.Item
                            label="Scheme Start Date"
                            name="schemeStartDate"
                            rules={rules.schemeStartDate}
                        >
                            <Space direction="vertical" size={12}>
                                <DatePicker
                                    format="DD/MM/YYYY"
                                    className={commonStyles.dateWidth}
                                    onChange={(date, dateString) => {
                                        onChangeStartDate(date, dateString)
                                    }}
                                    value={
                                        SchemeStartDate != null
                                            ? dayjs(SchemeStartDate)
                                            : null
                                    }
                                    allowClear
                                />
                            </Space>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <PostCodeInput
                            name="postCode"
                            label="Post Code"
                            reuireMessage="Please Enter Post Code"
                            placeHolder={''}
                            setAddressDetails={setAddress}
                            require={servicesEnabled}
                        />
                    </Col>
                </Row>

                <Row gutter={16} className={Servicesless.services}>
                    <Col span={12}>
                        <Form.Item
                            label="Address 1"
                            name="addressLineOne"
                            rules={rules.addressLineOne}
                        >
                            <Input allowClear maxLength={100} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="HMRC Gateway ID" name="gateWayId">
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={24} className={Servicesless.services}>
                    <Col span={12}>
                        <Form.Item label="CIS Filing" name="csiFiling">
                            {' '}
                            <Switch
                                onChange={handleServiceSwitchChange2}
                                checked={CSIEnabled}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Password" name="password">
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16} className={Servicesless.services}>
                    <Col span={12}>
                        {payrollFrequencyid === 'MONTHLY' ? (
                            <Form.Item
                                label="Paye Process Date"
                                name="payeProcess"
                            >
                                <Select
                                    allowClear
                                    showSearch
                                    placeholder="Please select"
                                    onChange={(value) => {
                                        hanldePayeProcessIdchange(value)
                                    }}
                                    options={[
                                        { label: 'Please select', value: 0 },
                                        ...payeProcessList?.map(
                                            (
                                                service: ListFrontEndInterface
                                            ) => ({
                                                value: service.value,
                                                label: service.label,
                                            })
                                        ),
                                    ]}
                                />
                            </Form.Item>
                        ) : (
                            <Form.Item label="Enable/Disable Services">
                                <Switch
                                    onChange={handleServiceSwitchChange1}
                                    checked={servicesEnabled}
                                />
                            </Form.Item>
                        )}
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Filing Method"
                            name="filingMethodName"
                        >
                            <Select
                                allowClear
                                placeholder="Please select"
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    typeof option?.children === 'string' && // Ensure option.children is a string
                                    (option.children as string)
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                            >
                                <Option value="Nil Return">Nil Return</Option>
                                <Option value="Standard Filing">
                                    Standard Filing
                                </Option>
                                <Option value="Hours to be obtained WEEKLY">
                                    Hours to be obtained WEEKLY
                                </Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={24} className={Servicesless.services}>
                    <Col span={12}>
                        {payrollFrequencyid === 'MONTHLY' && (
                            <Form.Item label="Enable/Disable Services">
                                <Switch
                                    onChange={handleServiceSwitchChange1}
                                    checked={servicesEnabled}
                                />
                            </Form.Item>
                        )}
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="HMRC payment frequency"
                            name="hmrcPaymentFrequencyName"
                        >
                            <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    typeof option?.children === 'string' && // Ensure option.children is a string
                                    (option.children as string)
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                            >
                                <Option value="MONTHLY">MONTHLY</Option>
                                <Option value="QUATERLY">QUATERLY</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                {ActivePremission('3000', PermissionType.SAVE) ? (
                    <Row gutter={16}>
                        <Col offset={21} span={2}>
                            <Tooltip title="Save PAYE Service">
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        handleClick()
                                            .then(() => {
                                                console.log(
                                                    'Form submitted successfully'
                                                )
                                            })
                                            .catch((error: any) => {
                                                console.error(
                                                    'Error submitting form:',
                                                    error
                                                )
                                            })
                                    }}
                                    loading={buttonloading}
                                >
                                    <SaveOutlined />
                                </Button>
                            </Tooltip>
                        </Col>
                    </Row>
                ) : (
                    <></>
                )}
            </Form>
        </div>
    )
}

const mapStateToProps = (state: any): PayeStateInterface => {
    return {
        countryList: state.common.countryList,
        payeProcessList: state.common.payeProcessList,
    }
}
export default connect(mapStateToProps)(PayeForm)
